<template>
  <div id="page-product-details">
    <persona-form
        v-if="model.privileges"
        v-model="model"
        :loading="loading"
        ref="form"
        :card-title="cardTitle"
        :override-system-persona="overrideSystemPersona"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'personas.ipr-platform.list', params: { id } })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              v-if="canSave"
              @click="save"
              class="my-4"
              color="light"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import PersonaForm from "@/views/pages/personas/ipr-platform/PersonaForm";
import ViewModelMixin from "@/components/mixins/ViewModelMixin";
import NotificationMixin from "@/components/mixins/NotificationMixin";

export default {
  name: "ProductEdit",
  components: {
    PersonaForm
  },
  mixins: [ViewModelMixin,NotificationMixin],
  data() {
    return {
      loading: false,
      modelEntity: this.$api.iprPlatformPersonas,
      canSave: false,
      actions: ['View']
    };
  },
  watch: {
    'model.System': {
      handler(newValue) {
        this.canSave = !newValue;
      },
    }
  },
  computed: {
    cardTitle() {
      return `Persona: ${this.model.PersonaName}`;
    },
    userEmail() {
      const user = this.$store.getters['auth/user']

      return user.email;
    },
    overrideSystemPersona() {
      const overrideEmails = process.env.VUE_APP_SYSTEM_PERSONA_OVERRIDE_EMAILS;

      if (!overrideEmails || overrideEmails === '') {
        return false;
      }

      const user = this.$store.getters['auth/user']

      const overrideEmailsArray = overrideEmails.split(',');
      return overrideEmailsArray.includes(user.email);
    }
  },
  methods: {
    getParams() {
      return {
        ...this.model
      };
    },
    getReferenceId(fieldName) {
      if (!this.model[fieldName]) {
        return null;
      }

      return this.model[fieldName].id || null;
    },
    async fetch(id) {
      if (!this.modelEntity) {
        return;
      }

      try {
        this.loading = true;
        const {data} = await this.modelEntity.get(id);

        this.model = await this.setPrivileges(data.data);

      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false;
        if (!this.model.id) {
          this.not_found = true
        }
      }
    },
    async setPrivileges(data) {
      const privileges = {};

      data.privileges.forEach((privilege) => {
        const pageName = privilege.PageName;

        delete privilege.PageName;
        delete privilege.Persona_FK;
        delete privilege.Persona_Privileges_PK;

        privileges[pageName] = privilege;

        this.actions.forEach((action) => {
          privileges[pageName][action] = parseInt(privileges[pageName][action]);
        });
      });

      data.privileges = privileges;

      return data;
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      //  return;
      try {
        const {data} = await this.$api.iprPlatformPersonas.update(this.id, params);
        this.notifySuccess('Persona updated');
      } catch (e) {
        this.notifyError('Persona failed to be edited');
        console.error(e)
      } finally {
        this.loading = false;
        this.$router.back();
      }
    }
  },
};
</script>

<style scoped>

</style>
